module.exports = __webpack_public_path__ + "static/Transparenzbericht_2025-be615db0db9207b4a8aa8ba54989d09d.pdf";